module.exports = __webpack_public_path__ + "static/media/climate-plans-lost-in-data-matrix.6decde63.webp";